<template>
  <header class="header" id="header">
    <div class="inner">
      <router-link class="logo" to="/">
        <img alt="LMH Estates" src="../assets/logo.jpg" />
      </router-link>
      <div class="actions" v-if="misc">
        <a :href="'tel:' + misc.doncaster_telephone.replace(/ /g, '')" class="call" v-show="misc.doncaster_telephone">
          <font-awesome-icon icon="phone" />
          <span>
            Call us on
            <strong>{{ misc.doncaster_telephone }}</strong>
          </span>
        </a>
        <a :href="'mailto:' + misc.email" class="social" v-show="misc.email" aria-label="Email Us">
          <font-awesome-icon icon="envelope" />
        </a>
        <a
          :href="misc.facebook"
          class="social"
          rel="noreferrer"
          target="_blank"
          v-show="misc.facebook"
          aria-label="Facebook"
        >
          <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }" />
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["misc"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background: #253e52;
  z-index: 7;
  width: 100%;
  height: 10rem;
  color: white;
}

.logo {
  display: inline-block;
  margin: 1rem 0;
}

.logo img {
  height: 8rem;
}

.actions {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.actions a {
  display: inline-block;
  margin-right: 1rem;
}

.actions a.social {
  margin-left: 2rem;
  margin-right: 0;
}

.actions span {
  display: inline-block;
  padding-left: 1rem;
}

.actions svg {
  color: #d1ae54;
}

.actions a.search {
  display: none;
}

@media screen and (max-width: 1050px) {
  .logo {
    position: relative;
    left: 6rem;
  }
}

@media screen and (max-width: 980px) {
  header {
    z-index: 5;
  }
  .call.desktop,
  .call span {
    display: none;
  }
  .actions svg {
    color: white;
  }
  .actions {
    margin-right: 1rem;
  }
  .actions a {
    margin-right: 0;
    margin-left: 1.7rem;
    font-size: 2.2rem;
  }
  .actions a.search {
    display: inline-block;
  }
}

@media screen and (max-width: 500px) {
  .logo {
    left: 5rem;
    margin: 1.3rem auto;
  }
  .logo img {
    height: 5rem;
  }
  .header {
    height: 7.5rem;
  }
}
</style>
